export enum SenderProfileType {
    Invoice = 1,
    Procurement = 3,
    Sales = 4,
    SupplierWarehouse = 6,
    BuyerWarehouse = 7,
}
